<template>
  <div class="container">
    <div>
      <div class="row mt-5 mb-5 justify-content-center" style="display: block">
        <div style="margin-bottom: 1.5rem">
          <h2>
            <span style="font-size: 1.5rem"> {{ $t('title1') }}</span>
          </h2>
        </div>
        <div>
          <h2>{{ $t('title2') }}</h2>
        </div>
      </div>
    </div>

    <div class="left-right">
      <div class="left">
        <img class="leftImage" src="@/assets/images/Podohotel/main_architecture_image01.jpg" v-show="isLang === 0" />
        <img class="leftImage" src="@/assets/images/Podohotel/main_architecture_image01_en.jpg" v-show="isLang === 1" />
        <img class="leftImage" src="@/assets/images/Podohotel/main_architecture_image01_jp.jpg" v-show="isLang === 2" />
        <button class="reserveButton" @click="goLink('/p/Architecturalart')">
          <span>{{ $t('button_mobile') }}</span>
        </button>
      </div>
      <div class="right">
        <div class="rightContent">
          <div class="textTop">
            <img src="@/assets/images/Podohotel/main_architecture_image03.png" v-show="isLang === 0" />
            <img src="@/assets/images/Podohotel/main_architecture_image03_en.png" v-show="isLang === 1" />
            <img src="@/assets/images/Podohotel/main_architecture_image03_jp.png" v-show="isLang === 2" />
          </div>
          <div class="textDesc">
            <p v-html="$t('desc')"></p>
          </div>
          <button class="reserveButton" @click="goLink('/p/Architecturalart')">
            <span>{{ $t('button_web') }}</span>
          </button>
        </div>
        <img class="rightImage" src="@/assets/images/Podohotel/main_architecture_image02.jpg" />
      </div>
    </div>

    <!--    <div class="container mb-5">-->
    <!--      <div class="row">-->
    <!--        <div class="col-lg-4 col-12 mt-4 pt-2">-->
    <!--          <div class="card rounded border-1">-->
    <!--            <img-->
    <!--              src="@/assets/images/Podohotel/main_architecture_image04.jpg"-->
    <!--              class="card-img-top rounded-top"-->
    <!--              alt="..."-->
    <!--            />-->
    <!--            <div class="card-img-overlay text-white align-bottom">-->
    <!--              <h3 class="archi_text card-body">Private</h3>-->
    <!--            </div>-->
    <!--            <div class="card-img-overlay text-white align-bottom">-->
    <!--              <p class="archi_text card-body"><br /><br />나만의 공간에서 누리는 특별한 온천</p>-->
    <!--            </div>-->
    <!--          </div>-->
    <!--        </div>-->

    <!--        <div class="col-lg-4 col-12 mt-4 pt-2">-->
    <!--          <div class="card rounded border-1">-->
    <!--            <img-->
    <!--              src="@/assets/images/Podohotel/main_architecture_image05.jpg"-->
    <!--              class="card-img-top rounded-top"-->
    <!--              alt="..."-->
    <!--            />-->
    <!--            <div class="card-img-overlay text-white align-bottom">-->
    <!--              <h3 class="archi_text card-body">Nature & Harmony</h3>-->
    <!--            </div>-->
    <!--            <div class="card-img-overlay text-white align-bottom">-->
    <!--              <p class="archi_text card-body"><br /><br />제주 자연을 끌어 안은 휴식처</p>-->
    <!--            </div>-->
    <!--          </div>-->
    <!--        </div>-->

    <!--        <div class="col-lg-4 col-12 mt-4 pt-2">-->
    <!--          <div class="card rounded border-1">-->
    <!--            <img-->
    <!--              src="@/assets/images/Podohotel/main_architecture_image06.jpg"-->
    <!--              class="card-img-top rounded-top"-->
    <!--              alt="..."-->
    <!--            />-->
    <!--            <div class="card-img-overlay text-white align-bottom">-->
    <!--              <h3 class="archi_text card-body">Art</h3>-->
    <!--            </div>-->
    <!--            <div class="card-img-overlay text-white align-bottom">-->
    <!--              <p class="archi_text card-body"><br /><br />제주 7대 건축물의 아름다운 예술미</p>-->
    <!--            </div>-->
    <!--          </div>-->
    <!--        </div>-->
    <!--      </div>-->
    <!--    </div>-->
  </div>
</template>

<script>
export default {
  name: 'Architecturepodo',
  components: {},
  props: {
    item: {
      type: Object,
    },
  },
  data() {
    return {
      isLang: 0,
    };
  },
  methods: {
    goLink(url) {
      console.log('go');
      this.$router.push(url);
    },
    refreshLocale(newVal) {
      if (newVal === 'ko') {
        this.isLang = 0;
      } else if (newVal === 'en') {
        this.isLang = 1;
      } else if (newVal === 'ja') {
        this.isLang = 2;
      } else {
        this.isLang = 0;
      }
    },
  },
  watch: {
    '$i18n.locale'(newVal, oldVal) {
      this.refreshLocale(newVal);
    },
  },
  created() {
    this.refreshLocale(this.$i18n.locale);
  },
};
</script>

<style scoped lang="scss">
h2 {
  height: 2rem;
  text-align: center;
  color: #222222;
  font-family: 'Nanum Myeongjo', serif;
  font-weight: 700;
}

.left-right {
  display: flex;
  .left {
    width: 50%;
    .leftImage {
      width: 100%;
    }
    .reserveButton {
      display: none;
    }
  }

  .right {
    position: relative;
    width: 50%;
    .rightContent {
      text-align: left;
      margin-left: 3rem;

      .textTop {
        margin-top: 3rem;
      }

      .textDesc {
        margin-top: 2rem;
      }

      .reserveButton {
        display: inline-block;
        height: 100%;
        font-size: 0.9rem;
        padding: 0.5rem;
        width: 40%;

        background-color: #937348 !important;
        //padding: 0px !important;
        color: white;
        border: none;
        outline: none;
        span {
          padding: 0px;
          width: 100%;
          text-align: center;
          padding: 0px !important;
        }
        &:hover {
          background-color: #403a30 !important;
        }
      }
    }
    .rightImage {
      position: absolute;
      left: 0;
      bottom: 0;
      width: 100%;
    }
  }
}

@media (max-width: 992px) {
  h2 {
    font-size: 1.9rem !important;
  }

  .left-right {
    display: block;
    height: auto;
    .left {
      width: 100%;
      .leftImage {
        width: 100%;
      }
      .reserveButton {
        display: block;
        height: 100%;
        font-size: 1rem;
        padding: 0.5rem;
        width: 100%;
        margin-left: auto;
        margin-right: auto;

        background-color: #937348 !important;
        //padding: 0px !important;
        color: white;
        border: none;
        outline: none;
        span {
          padding: 0px;
          width: 100%;
          text-align: center;
          padding: 0px !important;
        }
        &:hover {
          background-color: #403a30 !important;
        }
      }
    }

    .right {
      display: none;
      position: relative;
      width: 100%;
      .rightContent {
        text-align: left;
        margin-left: 1rem;

        .textTop {
          height: 30%;
          margin-top: 1rem;
          text-align: center;
        }

        .textDesc {
          margin-top: 2rem;
          text-align: center;
        }

        .reserveButton {
          height: 100%;
          font-size: 1rem;
          padding: 0.5rem;
          width: 40%;
          margin-left: auto;
          margin-right: auto;

          background-color: #524a3d !important;
          //padding: 0px !important;
          color: white;
          border: none;
          outline: none;
          span {
            padding: 0px;
            width: 100%;
            text-align: center;
            padding: 0px !important;
          }
          &:hover {
            background-color: #403a30 !important;
          }
        }
      }
      .rightImage {
        width: 100%;
      }
    }
  }
}
</style>

<i18n>
{
  "ko": {
    "title1": "자연과 함께 숨쉬는 건축",
    "title2": "포도호텔",
    "button_mobile": "건축예술 가이드 프로그램",
    "desc": "건물은 그 대지와 같이 숨을 쉴 수 있어야 한다.<br />포도호텔 내부로 제주의 야생정원이 자연스레 흘러 들어오고<br />때때로 내부의 공간이 밖을 향해 열리기도 하면서<br />제주의 자연과 대화를 나누는 듯 조화를 이뤄야 한다.",
    "button_web": "건축예술 가이드 프로그램"
  },
  "en": {
    "title1": "PODO HOTEL",
    "title2": "BREATHES WITH NATURE",
    "button_mobile": "Architectural Art Guide Program",
    "desc": "The building should be able to breathe like the land it sits in.<br />Jeju's wild garden naturally flows into PODO Hotel.<br />Sometimes the inner spaces opens to outside.<br />It has to form a harmony as if it is communicating with Jeju's nature.",
    "button_web": "Architectural Art Guide Program"
  },
  "ja": {
    "title1": "自然と共に息づく建築",
    "title2": "ポドホテル",
    "button_mobile": "建築芸術ガイドプログラム",
    "desc": "建物はその大地と共に呼吸することができなければならない。<br />ポドホテルの内部に済州の野生の庭園が自然に流れ込み<br />時には内部の空間が外に向かって開かれ<br />済州の自然と対話しているかのように調和しなければならない。",
    "button_web": "建築芸術ガイドプログラム"
  }
}
</i18n>
